<template>
<v-card
    style="margin-bottom: 15px"
>
    <div
            style="position: absolute; top: 15px; right: 15px"
        >
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="$emit('move-up', field)"
                    v-if="field.index != 0"
                >
                    <v-list-item-title>Move Up</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="$emit('move-down', field)"
                    v-if="field.index < field_count-1"
                >
                    <v-list-item-title>Move Down</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickDelete()"
                >
                    <v-list-item-title>Delete...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </div>

    <v-card-text
    >
        <v-select
            label="Question Type"
            v-model="field.type"
            :items="question_type_choices"
            v-on:change="onChangeFieldType"
            style="margin-top: 15px"
        />

        <v-alert
            v-if="$rc.isBlank(field.label)"
            border="left"
            colored-border
            color="primary"
            elevation="2"
            type="info"
        >
            A blank label is not allowed.
        </v-alert>

        <v-text-field
            label="Label"
            v-model="field.label"
            v-on:input="put"
            autocomplete="off"
            v-show="field.type != 'payment'"
        />

        

        <v-text-field
            label="Extended Description"
            v-model="field.extended_description"
            v-on:input="put"
            autocomplete="off"
            v-show="field.type != 'payment'"
        />

        <v-text-field
            label="Hint"
            v-model="field.hint"
            v-on:input="put"
            autocomplete="off"
            v-show="field.type != 'payment'"
        />

        <v-select
            label="Required"
            v-model="field.required"
            :items="$rc.enumChoices('form_field_required',false)"
            v-on:change="doPut"
            v-show="field.type != 'payment'"
        />

       

    
        <div
            v-if="field.type == 'multiple-choice'"
        >
            <b>Choices</b>

            <v-switch
                label="Allow multiple choices to be selected"
                v-model="field.allow_multiple_select"
                v-on:change="doPut"
            />

            <v-text-field
                v-for="(item, index) in field.choices"
                :key="index"
                v-model="item.text"
                label="Choice Text"
                style="margin-left: 30px"
                v-on:input="put"
                autocomplete="off"
            >
                <v-menu
                    bottom
                    offset-y
                    slot="append-outer"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                    </template>
            
                    <v-list>
                        <v-list-item
                            v-on:click="onClickMoveChoiceUp(item, index)"
                        >
                            <v-list-item-title>Move up</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickMoveChoiceDown(item, index)"
                        >
                            <v-list-item-title>Move down</v-list-item-title>
                        </v-list-item>

                        <v-divider/>

                        <v-list-item
                            v-on:click="onClickDeleteChoice(item, index)"
                        >
                            <v-list-item-title>Delete...</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-text-field>

            <div
                style="text-align: right"
            >
                <v-btn
                    v-on:click="onClickAddChoice"
                >
                    Add Choice...
                </v-btn>
            </div>
        </div>

        <div
            v-if="field.type == 'number'"
        >
            <v-row>
                <v-col>
                    <v-text-field
                        label="Minimum Value"
                        v-model.number="field.number_min_value"
                        v-on:change="put"
                        autocomplete="off"
                    />
                </v-col>

                <v-col>
                    <v-text-field
                        label="Maximum Value"
                        v-model.number="field.number_max_value"
                        v-on:change="put"
                        autocomplete="off"
                    />
                </v-col>
            </v-row>

        </div>

        <div
            v-if="field.type == 'payment'"
        >
            <m-edit-select-employee
                :organization_id="this.profile.form.organization_id"
                v-model="field.payment_assign_to_employee_id"
                v-on:input="doPut"
                label="RedChirp User (will own and be notified of the payment)"
            />

            <v-textarea
                label="Item Description (optional)"
                v-model="field.payment_description"
                hint="Describes the transaction to the customer."
                :rows="1"
                auto-grow
                v-on:input="doPut"
            />

            <v-radio-group
                v-model="field.payment_type"
                row
                v-on:change="doPut"
                style="margin-bottom: -10px; margin-top: -5px"
            >
                <v-radio
                    label="One Time Payment"
                    value="one-time-payment"
                />
                <v-radio
                    label="Subscription"
                    value="subscription"
                />
            </v-radio-group>

             <m-edit-monetary-amount
                v-if="field.payment_type == 'one-time-payment'"
                label="Amount"
                :suffix="field.payment_currency"
                v-model="field.payment_amount"
                v-on:input="doPut"
                autocomplete="off"
            />

            <v-text-field
                v-if="field.payment_type == 'subscription'"
                label="Purpose"
                v-model="field.payment_for_message"
                hint="That is, why are you asking them for their credit card (e.g. &quot;Place a card on file&quot;, &quot;Monthly fee&quot;, etc.)"
                v-on:input="doPut"
                persistent-hint
                style="margin-bottom: 15px; margin-top: -15px"
            />

            <v-select
                label="Address Information"
                :items="$rc.enumChoices('payment_address_info_request',false)"
                v-model="field.payment_amount_of_address_information"
                v-on:change="doPut"
            />

            <v-select
                label="Email Address"
                :items="$rc.enumChoices('payment_request_ex_field_display_state', false)"
                v-model="field.payment_ex_field_email"
                v-on:change="doPut"
            />

            <v-select
                label="Age Verification"
                :items="$rc.enumChoices('age_verification_requirement',false)"
                v-model="field.payment_age_verification_requirement"
                hint="Require a verification method to ensure the recipient is at least a minimum age"
                persistent-hint
                v-on:change="doPut"
            />

            <v-text-field
                v-show="field.payment_age_verification_requirement != 'none'"
                label="Minimum Age (Years)"
                v-model="field.payment_min_age_in_years"
                v-on:input="doPut"
                autocomplete="off"
            />


        </div>
    </v-card-text>
</v-card>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        field: {
            type: Object,
            default: function() { return {}; }
        },

        field_count: {
            type: Number,
            default: function() { return 0; }
        },

        other_fields: {
            type: Array,
            default: function() { return []; }
        },

        profile: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        put: _.debounce(function(){
            this.doPut();
        }, 751),
        
        doPut()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/forms/custom-field',
            
                'params' : this.field,
            
                'on_success': (data) => {
                        this.$emit('change');
                    },
            
                'on_error': 'Unable to save field',
            });
        },

        onClickAddChoice()
        {
            this.field.choices.push(
                {
                    'text': 'New choice',
                    'value': this.$rc.uuidv4(),
                }
            );

            this.doPut();
        },

        onClickMoveChoiceUp(item, index)
        {
            if ( index == 0 ) 
                return;

            let tmp = this.field.choices[index-1];
            this.field.choices[index-1] = item;
            this.field.choices[index] = tmp;

            this.doPut();
            this.$forceUpdate();
        },

        onClickMoveChoiceDown(item, index)
        {
            if ( index >= this.field.choices.length-1 ) 
                return;

            let tmp = this.field.choices[index+1];
            this.field.choices[index+1] = item;
            this.field.choices[index] = tmp;

            this.doPut();
            this.$forceUpdate();
        },
        

        onClickDelete()
        {
            this.$rc.confirm({
                'title': 'Delete this field?',
                'body': 'Delete the field: "'+this.field.label+"\"?<br/><br/>This can not be undone.",
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doDelete();
                },
            });
        },

        doDelete()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'DELETE: /api/v1/forms/custom-field',
            
                'params' : {
                        'form_field_id': this.field.form_field_id,
                    },
            
                'on_success': (data) => {
                        this.$emit('delete');
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickDeleteChoice(item, index)
        {
            this.$rc.confirm({
                'title': 'Delete this choice?',
                'body': 'Delete the choice: "'+item.text+"\"?",
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doDeleteChoice(item,index);
                },
            });
        },

        doDeleteChoice(item, index)
        {
            this.field.choices.splice(index,1);
            this.doPut();
            this.$forceUpdate();
        },

        onChangeFieldType(value)
        {
            if ( value == 'payment' )
            {
                this.field.label = 'Payment Information';
                this.field.required = 'required';
                if ( this.field.payment_type == null ) this.field.payment_type = 'one-time-payment';
                if ( this.field.payment_currency == null ) this.field.payment_currency = 'USD';
                if ( this.field.payment_amount_of_address_information == null ) this.field.payment_amount_of_address_information = 'billing-zip-code';
                if ( this.field.payment_ex_field_email == null ) this.field.payment_ex_field_email = 'do-not-show';
                if ( this.field.payment_age_verification_requirement == null ) this.field.payment_age_verification_requirement = this.profile.organization_account.payment_settings.default_age_verification_requirement;
                if ( this.field.payment_min_age_in_years == null ) this.field.payment_min_age_in_years = this.profile.organization_account.payment_settings.default_min_age_in_years;
                if ( this.field.payment_assign_to_employee_id == null ) this.field.payment_assign_to_employee_id = this.$rc.$state.getEmployeeId();
            }

            this.doPut();
        },

    },

    computed: {
        question_type_choices() {
            let ret = this.$rc.enumChoices('form_field_type',false);

            let has_payment_method = this.other_fields.find((item) => { return item.type == 'payment'; }) != null;

            if ( !has_payment_method )
                return ret;

            return ret.filter((item) => { return item.value != 'payment';});
        }
    },
}
</script>

<style lang="scss" scoped>

</style>